import { Link, useParams, useSearchParams } from "react-router-dom";
import { firebaseListo } from "../lib/firebase";
import { enlaceWhatsApp } from "../lib/envios";
import { EMPRESA } from "../lib/config";
import s from "./Comercio.module.css";

export default function Confirmacion() {
  const { codigo } = useParams();
  const [params] = useSearchParams();
  const tipo = params.get("tipo") === "pedido" ? "pedido" : "cotizacion";

  const esPedido = tipo === "pedido";

  return (
    <div className={`container ${s.confirmacion}`}>
      <span className={s.checkGrande} aria-hidden="true">
        ✓
      </span>

      <p className="eyebrow">{esPedido ? "Pedido registrado" : "Solicitud enviada"}</p>

      <h1 className={s.tituloPagina}>
        {esPedido ? "Recibimos tu pedido" : "Recibimos tu solicitud"}
      </h1>

      <p className={s.vacioTexto}>
        Guarda este codigo: con el podemos ubicar tu{" "}
        {esPedido ? "pedido" : "cotizacion"} en cualquier momento.
      </p>

      <p className={s.codigo}>{codigo}</p>

      <ol className={s.pasos}>
        <li>
          Un asesor revisa la disponibilidad y confirma precios y plazo de
          entrega.
        </li>
        <li>
          Te contactamos al correo y telefono que registraste, dentro de las
          proximas 24 horas habiles.
        </li>
        <li>
          {esPedido
            ? "Al confirmar, te enviamos los datos de pago y programamos el despacho."
            : "Recibiras la cotizacion formal en PDF con IGV y flete incluidos."}
        </li>
      </ol>

      {!firebaseListo && (
        <p className={s.nota}>
          Esta web todavia no tiene el backend conectado, asi que la solicitud
          no quedo guardada en el sistema. Envianos el codigo por WhatsApp para
          que no se pierda.
        </p>
      )}

      <div className={s.vacioAcciones}>
        <a
          className="btn btn--accent"
          href={enlaceWhatsApp(
            `Hola ${EMPRESA.nombre}, acabo de enviar ${
              esPedido ? "un pedido" : "una solicitud de cotizacion"
            } con el codigo ${codigo}.`
          )}
          target="_blank"
          rel="noopener noreferrer"
        >
          Avisar por WhatsApp
        </a>
        <Link to="/productos" className="btn btn--ghost">
          Seguir viendo el catalogo
        </Link>
      </div>
    </div>
  );
}
